import React from 'react';
import { Table } from './table';
export const TableForm: React.FC = ({ children }) => {
  return (
    <Table>
      <tbody>{children}</tbody>
    </Table>
  );
};
